(function(body, headerContainer, helperFunctions){

  let latestKnownScrollY = 0,
      ticking = false;

  function updateIndicator(article, articleTop, scrollY) {
    scrollY = scrollY || window.pageYOffset
    let percentageNumber = Math.round((scrollY - articleTop / 2 + headerContainer.clientHeight) / article.scrollHeight * 100) / 100
    // Do the rounding manually, for some reason helperFunctions.limitNumberWithinRange() doesn't work here
    let percentage = Math.min(Math.max(percentageNumber, 0), 1)
    headerContainer.style.setProperty('--indicator-width', percentage)
  }

  // Wait for this event to be fired so that we know rendering is done
  // which results in more reliable calculations
  window.addEventListener('load', function(){
    if (body && body.classList.contains('article-js')) {
      const article = document.querySelector('article.article-page .content-sections'),
            articleTop = helperFunctions.getDistanceFromTop(article);

      // Based on article https://www.html5rocks.com/en/tutorials/speed/animations/
      // Optimising animations using requestAnimationFrame()
      // Fundamental ideas:
      // 1. Only run animation if user has scrolled - this saves battery/power
      // 2. Let browser decide when it can run animation - this is what requestAnimationFrame() does
      // 3. Loop through this flow and then update the scroll position values
      // 4. Profit!
      function update() {
        ticking = false

        let currentScrollY = latestKnownScrollY

        updateIndicator(article, articleTop, currentScrollY)
      }

      function onScroll() {
        latestKnownScrollY = window.scrollY
        requestTick()
      }

      function requestTick() {
        if(!ticking) {
          requestAnimationFrame(update)
        }
        ticking = true
      }

      if (article && article.clientHeight > 0)  {
        updateIndicator(article, articleTop)

        document.addEventListener('scroll', function(){
          // Call onScroll function so that we can take advantage of animation frames
          onScroll()
        }, {passive: true})
      }
    }
  })
})(body, headerContainer, helperFunctions);
